export default __webpack_public_path__ + "static/ubuntu-v20-latin-700-6788e6ed863a8e559ef28b3913554383.woff";